// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1525":"image-crop","3839":"pdf","5902":"heic"}[chunkId] || chunkId) + "." + {"1046":"850a89db21b61f19","1525":"98bf7acef50a26b1","3839":"69d0f81fca1acba2","5902":"fc6195a2816360ec"}[chunkId] + ".js";
};